import { Lock, LockOpen } from "@mui/icons-material"
import { Chip } from "@mui/material"

/**
 * A React component that displays a chip indicating whether a value is encrypted or not.
 *
 * @param {Object} props - The props object.
 * @param {boolean} props.encrypted - A boolean indicating if the value is encrypted.
 * @returns {JSX.Element} A styled chip component with an icon and label representing the encryption state.
 */
export function EncryptedCell({ encrypted }) {
  return (
    <Chip
      size="small"
      sx={{ maxWidth: 'fit-content', p: 0.5 }}
      icon={encrypted ? <Lock /> : <LockOpen />}
      label={encrypted ? 'Encrypted' : 'Not Encrypted'}
      variant={encrypted ? 'filled' : 'outlined'}
      color={encrypted ? 'info' : 'default'}
    />
  )
}